<template>
  <div>
    <RankingComponent/>   
  </div>

</template>

<script>
import RankingComponent from "@/components/Ranking.vue";
export default {
  name: "RankingView",
  components: {
    RankingComponent
  }
};
</script>

